import { ApolloError } from 'apollo-client';
import { AmberHoc, AmberHocProps } from '../../../util';
import {
  InventoryCalculationParametersFragmentFragment as Result,
  withInventoryCalculationParametersQuery as HOC,
} from '../__generated';

export type WithInventoryCalculationParametersHocOwnProps = {
  grain_bin_id: number;
  loading?: boolean;
  onError?: (error: ApolloError) => void;
};

export type WithInventoryCalculationParametersHocChildProps = {
  loading: boolean;
  refetchInventoryCalculationParameters: () => Promise<any>;
  inventory_calculation_parameters: Result | null;
};

export const withInventoryCalculationParametersHoc: AmberHoc<
  WithInventoryCalculationParametersHocOwnProps,
  WithInventoryCalculationParametersHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<
      WithInventoryCalculationParametersHocOwnProps,
      WithInventoryCalculationParametersHocChildProps,
      typeof component
    >,
    WithInventoryCalculationParametersHocChildProps
  >({
    options: ({ onError, grain_bin_id }) => ({
      onError,
      variables: { grain_bin_id },
      errorPolicy: onError ? 'all' : 'none',
    }),
    props: ({ data, ownProps: { loading } }) => {
      if (!data || data.loading) {
        return {
          refetchInventoryCalculationParameters: () => Promise.resolve(),
          loading: true,
          inventory_calculation_parameters: null,
        };
      }
      return {
        refetchInventoryCalculationParameters: () => data.refetch(),
        loading: loading || false,
        inventory_calculation_parameters: data.inventory_calculation_parameters || null,
      };
    },
  })(component as any);
